import GradientContainer from "@app/components/gradient/gradient-container"

const MobileIndustriesGradient = () => {
  return (
    <div className="w-full">
      <GradientContainer overrideClassName="py-10 px-3 space-y-2 text-center flex flex-col items-center justify-center">
        <p className="h3 text-light">
          Diversity
        </p>
        <p className="text-body-lg text-light">
          Representing clients in every industry.
        </p>
      </GradientContainer>
    </div>
  )
}

export default MobileIndustriesGradient;
